import { useEffect } from "react";

/** Tiny redirect to the standalone Club Vacacional sales course HTML. */
const CursoClubVacacionalRedirect = () => {
  useEffect(() => {
    window.location.replace("/cursoclubvacacional.html");
  }, []);
  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#0D1B2A",
      color: "#C9A84C",
      fontFamily: "system-ui, sans-serif",
      fontSize: "14px",
      letterSpacing: "2px",
      textTransform: "uppercase",
    }}>
      Cargando curso…
    </div>
  );
};

export default CursoClubVacacionalRedirect;
